import React from 'react';
import {
  Box,
} from '@mui/material';
import { GroundTruthRatio } from '../../redux/types';

type Props = {
  payload: GroundTruthRatio['payload'];
};

const GTRatioScore: React.FC<Props> = ({
  payload,
}: Props) => (
  <Box>{`${payload.score} (${payload.answer[0]} : ${payload.answer[1]})`}</Box>
);

export default GTRatioScore;
